<template>
  <div id="cup_teamDetail_playerList" v-if="playerList_data && currThemeObj">
    <teamDetail_playerList
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :list="playerList_data"
    ></teamDetail_playerList>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import teamDetail_playerList from '../teamDetail_playerList.vue'
import { https_cup_teamPlayerList } from '@api/platfrom_football_api'
export default {
  name: 'cup_teamDetail_playerList',
  components: {
    teamDetail_playerList,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      playerList_data: null,
      // [
      //   {
      //     id: 1,
      //     floor1_title: '12312',
      //     floor2_image: '',
      //     floor2_no: 12,
      //     floor2_pos: '守门员',
      //     floor2_status: '大名单',
      //     floor3_list: [
      //       {
      //         key: 'asd',
      //         name: '出场',
      //         val: 3,
      //       },
      //       {
      //         key: 'asd1',
      //         name: '扑救',
      //         val: 3,
      //       },
      //       {
      //         key: 'asd2',
      //         name: '扑救成功',
      //         val: 3,
      //       },
      //     ],
      //   },
      // ],
    }
  },
  created() {
    console.debug('route:', this.$route)
    const query = this.$route.query
    this.init(query)
  },
  methods: {
    async init(query) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.getTeamPlayerList(query)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getTeamPlayerList(query) {
      await https_cup_teamPlayerList(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.playerList_data = res.data
              ? res.data.map((val) => {
                  const data = val.data
                  let listKey = []
                  if (data.sort == 4) {
                    // 守门员
                    listKey = [
                      {
                        key: 'gamesPlayed',
                        name: '出场',
                        val: '',
                      },
                      {
                        key: 'goals',
                        name: '扑救',
                        val: '',
                      },
                      {
                        key: 'assists',
                        name: '扑救成功',
                        val: '',
                      },
                    ]
                  } else {
                    listKey = [
                      {
                        key: 'gamesPlayed',
                        name: '出场',
                        val: '',
                      },
                      {
                        key: 'goals',
                        name: '进球',
                        val: '',
                      },
                      {
                        key: 'assists',
                        name: '助攻',
                        val: '',
                      },
                    ]
                  }
                  let player = {
                    pid: data.playerId,
                    tid: data.teamId,
                    floor1_title: data.playerName,
                    floor2_image: data.playerLogo,
                    floor2_no: data.shirtNumber,
                    floor2_pos: data.position,
                    floor2_status: data.active,
                    floor3_list: listKey.map((item) => {
                      item.val = data[item.key]
                      return item
                    }),
                  }
                  return player
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_teamDetail_playerList {
  padding-bottom: 2.778vw;
}
</style>
